<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CentroCusto from '@/src/services/centro-custo'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading },
  data() {
    return {
      filter: '',
      mostraForm: true,
      centroCusto: [],
      centroCustoEdit: {},
      centroCustoField: [        
        {
          key: 'descricao',
          label: 'Descrição',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
    }
  },
  computed: {},

  watch: {
    mostraForm() {
      if (this.mostraForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
    this.centroCustoEdit.ativo = true;
  },
  methods: {
    listando() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      CentroCusto.listar(token)
        .then((resposta) => {
          this.centroCusto = resposta.data.centros
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    editRegister(centroCusto) {
      this.centroCustoEdit = centroCusto
      this.mostraForm = false
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      if (this.centroCustoEdit.id) {
       this.isLoading = true;
        CentroCusto.atualizarCentroCusto(token, this.centroCustoEdit)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = false;
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = false;
          })
      } else {
        this.isLoading = true;
        CentroCusto.salvar(token, this.centroCustoEdit)
          .then((resposta) => {
            this.isLoading = false;
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.centroCustoEdit = {}
          })
          .catch((erro) => {
            this.isLoading = false;
            this.$bvToast.toast(
              erro.response ? erro.response.data.data : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
      }
    },
    modalDelete(item) {
      this.$bvModal.show('modal-delete')
      this.idUserDelete = item
    },
    handleDelete() {
      this.isLoading = true;
      const token = this.$store.state.auth.currentUser.token
      CentroCusto.deleteCentroCusto(token, this.idUserDelete)
        .then((reposta) => {
          this.isLoading = false;
          this.listando()
        })
        .catch((err) => {
          this.$bvModal.hide('modal-delete')
          this.isLoading = false;
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idUserDelete = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Centro de Custo</div>
            <div class="subTitulo">
              Registre os Centros de Custos aqui.
            </div>
          </div>
          <div class="col-md-2">
            <div class="float-right">
              <button class="btn btn-primary" @click="cadastra">
              <span v-if="mostraForm">Novo</span>
              <span v-else>Visualizar Centro de Custo</span>
            </button>
            </div>            
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="row" v-if="mostraForm">
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Descrição" label-for="filter">
            <b-form-input
              id="filter"
              v-model="filter"
              type="text"
              placeholder="Digite o filtro de busca"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div v-if="mostraForm">
        <b-table
          striped
          hover
          responsive="sm"
          borderless
          bordered
          outlined
          small
          :items="centroCusto"
          :fields="centroCustoField"
          :per-page="perPage"
          :filter="filter"
        >
          <template v-slot:cell(actions)="row">
            <div class="btn-group mb-2">
              <button
                v-b-tooltip.hover
                title="Editar"
                type="button"
                class="btn btn-light"
                @click="editRegister(row.item)"
              >
                <i class="uil uil-edit"></i>
              </button>
              <button
                v-b-tooltip.hover
                title="Deletar"
                type="button"
                class="btn btn-light"
                @click="modalDelete(row.item.id)"
              >
                <i class="uil uil-trash-alt"></i>
              </button>
            </div>
          </template>
          <template v-slot:cell(ativo)="row">{{
            row.item.ativo ? 'Sim' : 'Não'
          }}</template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          size="md"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>

      <div v-else>
        <b-form>
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col">
                  <b-form-group label="Descrição">
                    <b-form-input v-model="centroCustoEdit.descricao" />
                  </b-form-group>
                </div>
                <div class="col">
                  <b-form-group label="Ativo">
                    <b-form-checkbox v-model="centroCustoEdit.ativo" switch/>
                  </b-form-group>
                </div>
              </div>            
            </div>
          </div>
          <b-button type="submit" variant="primary" @click.prevent="salvar"
            >Salvar</b-button
          >
        </b-form>
      </div>
    </div>

    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="primary" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>